import { makeStyles } from '@mui/styles'
import { light } from '@mui/material/styles/createPalette'

const flagImage =
	// eslint-disable-next-line max-len
	'https://cdn.scoreapp.com/cdn-cgi/image/onerror=redirect,format=webp,quality=75,fit=scale-down/https://cdn.scoreapp.com/assets/platform/flags.png'

const useStyles = makeStyles(
	({ spacing, palette, typography, shadows }) => ({
		root: {
			'& $focused $notchedOutline': {
				borderWidth: 1,
			},
			'& .iti': {
				width: '100%',
				display: 'flex',
			},
			'& .iti__flag-container': {
				zIndex: 101,
				flexShrink: 0,
				right: ({ localeTextDirection }) => (localeTextDirection === 'rtl' ? 0 : null),
			},
			'& .iti__selected-flag': {
				padding: ({ localeTextDirection }) =>
					localeTextDirection === 'rtl' ? spacing(0, 2, 0, 1) : spacing(0, 1, 0, 2),
				'& .iti__flag': {
					backgroundImage: `url("${flagImage}")`,
				},
			},
			'& .iti $input': {
				zIndex: 100,
				width: 1,
				flexGrow: 1,
				margin: 1,
				padding: ({ localeTextDirection }) =>
					localeTextDirection === 'rtl' ? '10.5px 60px 10.5px 14px' : '10.5px 14px 10.5px 60px',
			},
			'& .iti--allow-dropdown .iti__flag-container:hover .iti__selected-flag': {
				background: 'none',
			},
			'& .iti__arrow': {
				borderWidth: spacing(0.54),
				borderTopColor: palette.common.placeholder,
				marginRight: ({ localeTextDirection }) => (localeTextDirection === 'rtl' ? '6px' : null),
			},
			'& .iti__arrow--up': {
				borderBottomColor: palette.common.placeholder,
			},
		},
		dropdown: {
			'& .iti__flag': {
				backgroundImage: `url("${flagImage}")`,
			},
			'& .iti--container': {
				...typography.caption,
				borderRadius: 5,
				overflow: 'hidden',
				boxShadow: shadows[1],
				color: light.text.secondary,
			},
			'& .iti__country-list': {
				position: 'static',
				height: '100%',
				padding: '8px 0',
				border: 'none',
				maxHeight: 'none',
				whiteSpace: 'normal',
			},
			'& .iti__country': {
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				padding: '6px 16px',
			},
		},
		dropdownAbsolute: {
			position: 'relative',
			'& .iti--container': {
				width: '100%',
				top: 'unset !important',
				left: 'unset !important',
				bottom: 'unset !important',
				right: 'unset !important',
				position: 'absolute',
				height: 300,

				marginTop: 8,
			},
		},
		dropdownFixed: {
			'& .iti--container': {
				zIndex: 1500,
			},
		},
		transparent: ({ usePaperColors }) => {
			const placeholderColor = palette.calcContrastColor(
				palette.common.placeholder,
				palette.augmentColor({ color: { main: palette.background[usePaperColors ? 'paper' : 'default'] } })
					.light,
			)

			return {
				'& .iti__arrow': {
					borderTopColor: placeholderColor,
				},
				'& .iti__arrow--up': {
					borderBottomColor: placeholderColor,
				},
				'& .iti $input': {
					'&::placeholder': {
						color: placeholderColor,
						opacity: 0.5,
					},
				},
			}
		},
		notchedOutline: {},
		input: {
			direction: ({ localeTextDirection }) => localeTextDirection || 'ltr',
		},
		focused: {},
	}),
	{ name: 'Form-PhoneNumber' },
)

export default useStyles
